import { Api } from './api/api';
import { Items } from '../mocks/providers/items';
import { Settings } from './settings/settings';
import { User } from './user/user';
import { GlobalNotificationsProvider } from './global-notifications/global-notifications';

export {
    Api,
    Items,
    Settings,
    User,
    GlobalNotificationsProvider
};



// WEBPACK FOOTER //
// ./src/providers/providers.ts